<script lang="ts">
import Vue from "vue";
import { FeedbackModal } from "@twiage/feedback-form";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "LocalFeedbackModal",
  components: {
    FeedbackModal
  },
  computed: {
    ...mapGetters("Feedback", ["isOpen", "isError", "isLoading"])
  },
  watch: {
    isOpen() {
      const dialog = document.getElementById("feedback-form") as HTMLDialogElement;
      this.isOpen ? dialog.showModal() : dialog.close();
    }
  },
  mounted() {
    this.setupDialog();
  },
  methods: {
    ...mapActions("Feedback", ["open", "close", "submitFeedback", "reset"]),
    getDialog() {
      return document.getElementById("feedback-form") as HTMLDialogElement;
    },
    getTextArea() {
      return document.querySelector("#feedback-form > form > textarea") as HTMLTextAreaElement;
    },
    setupDialog() {
      const dialog = this.getDialog();
      dialog?.addEventListener("close", this.close);
      this.getTextArea()?.addEventListener("input", this.reset);
    },
    _submitFeedback(message: string) {
      this.submitFeedback(message);
      this._close();
    },
    _close() {
      this.close();
      const textArea = this.getTextArea();
      if (textArea) {
        textArea.removeEventListener("input", this.reset);
        textArea.value = "";
      }
    }
  }
});
</script>

<template>
  <feedback-modal
    data-test-id="feedback-modal"
    :is-loading="isLoading"
    :is-failed="isError"
    :on-close="_close"
    :on-save="_submitFeedback"
  />
</template>

<style scoped></style>
